/*
 * File: CreateImageStory.styles.js
 * Project: our-wave-stories-app
 *
 * Created by Brendan Michaelsen on April 20, 2025 at 11:54 PM
 * Copyright © 2025 Our Wave, Inc. All rights reserved.
 *
 * Last Modified: May 26, 2025 at 2:52 PM
 * Modified By: Brendan Michaelsen
 */

/**
 * Imports
 */

// Modules
import styled from 'styled-components';

// Components
import { LegalSnippet as LegalSnippetBase } from '../../LegalSnippet';

// Constants
import { mobileBreakpoint, ShareBottomPadding, ShareTopbarHeight } from '../../../styles/constants';


/**
 * Constants
 */

const MAX_UPLOAD_HEIGHT = {
	MOBILE: '300px',
	DESKTOP: '250px'
};


/**
 * Styles
 */

export const StepContainer = styled.div`
	width: 100%;
	min-height: calc(100vh - ${ShareTopbarHeight}px - ${ShareBottomPadding}px);
	display: flex;
	align-items: center;
	justify-content: center;
`;

export const InnerStep = styled.div`
	width: 100%;
	max-width: 700px;
	padding: 50px 0px 50px;
`;

export const ContentContainer = styled.div`
	p {
		margin: 10px 0px 0px;
	}
	br {
		margin: 10px;
	}
`;

export const ActionContainer = styled.div`
	margin: 30px 0px 0px;
	display: flex;
	gap: 10px;
`;

export const LegalSnippet = styled(LegalSnippetBase)`
	margin: 30px 0px 0px;
`;

export const InputContainer = styled.div`
	margin: 30px 0px 20px;

	input {
		height: 55px;
		margin: 12px 0px 12px;
	}
`;

export const Warnings = styled.div`
	margin: 0px 0px 40px;

	p:not(:first-child) {
		margin-top: 10px;
	}
`;

export const DragZoneInner = styled.div`
	display: flex;
	flex-direction: column;
	align-items: center;
	justify-content: center;
	width: 100%;
	height: ${MAX_UPLOAD_HEIGHT.MOBILE};
	position: relative;

	@media only screen and (min-width: ${mobileBreakpoint}em) {
		height: ${MAX_UPLOAD_HEIGHT.DESKTOP}
	}
	svg {
		color: ${({ theme }) => theme.obfuscationGreyText};
		font-size: 2.6rem;
		margin-bottom: 20px;
	}
	h5 {
		font-size: 1.0rem;
	}
	p {
		margin-top: 10px;
		color: ${({ theme }) => theme.secondaryText};
	}
	button {
		margin-top: 25px;
	}
`;

export const FilePreview = styled.div`
	position: relative;
	max-width: 100%;
	max-height: 100%;
`;

export const FileContainer = styled.img`
	height: auto;
	width: auto;
	max-width: 100%;
	max-height: 100%;
	border: 1px solid ${({ theme }) => theme.layoutBorder};
	border-radius: 6px;
`;

export const RemoveButton = styled.button`
	width: 26px;
	height: 26px;
	border-radius: 50%;
	border: 1px solid ${({ theme }) => theme.layoutBorder};
	background-color: ${({ theme }) => theme.neutralButton};
	position: absolute;
	top: -13px;
	right: -13px;
	display: flex;
	align-items: center;
	justify-content: center;
	cursor: pointer;
	z-index: 5;
	margin: 0px !important;

	svg {
		color: ${({ theme }) => theme.secondaryText};
		font-size: 0.9rem;
		margin: 0px !important;
	}
`;
